<section>
  <div class="sx-dialog__small sx-dialog__scroll-area">
    <header class="sx-dialog__content">
      <h2 class="sx-dialog__heading h3">{{title}}</h2>
    </header>
    @if(showListOfErrors){
      <div class="sx-dialog__content">
        @if(data.validationErrors && data.validationErrors.length > 0){
          <ul>
              @for(item of data.validationErrors; track item;){
                <li [innerHtml]="message"></li>
              }
              
          </ul>
        }
      </div>
    }
    @else {
      <div class="sx-dialog__content">
        @if(data.validationErrors && data.validationErrors.length > 0){
          <div>
              <div class="sx-dialog__content--text-small" [innerHtml]="message"></div>
          </div>
        }
      </div>
    }

  </div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
    <button class="sx-button sx-button--magenta" id="dialog_close_btn" mat-button [mat-dialog-close]="true">{{ 'core.button.close' | translate }}</button>
  </div>
</section>
